import { FC } from 'react'

import { DashboardInformation } from 'src/components/organisms'
import { ApprovalRequest } from 'src/components/organisms/approvalRequests/ApprovalRequest'

import { useGetMyReviewingConfirmations, useGetProfile } from 'src/hooks'

type Props = {
  className?: string
}

export const Dashboard: FC<Props> = ({ className }) => {
  const { profile } = useGetProfile()
  const { myReviewingConfirmations } = useGetMyReviewingConfirmations({ isEnabledPolling: true })

  return (
    <div className={className}>
      <div className="tw-mt-s3 tw-pb-s5 tw-px-s1">
        <section className="tw-max-w-[895px] tw-w-full tw-grid tw-gap-s2">
          {myReviewingConfirmations.length > 0 && (
            <ApprovalRequest myReviewingConfirmations={myReviewingConfirmations} />
          )}
          {profile && <DashboardInformation className="tw-w-full" />}
        </section>
      </div>
    </div>
  )
}
